import React, { useState, useEffect } from 'react';
import { Card, Button, Row, Col, Accordion } from 'react-bootstrap';
import SDMa04_DateSelector from "./SDMa04_DateSelector"
import SDMa05_TableRow from "./SDMa05_TableRow"
import BlockColorCode from "../../Devices/DevServices/BlockColorCode"

const SDMa01accordionWrap = (props) => {
    const {
      selected_desk_skeleton_mobile,
      update_mobile_actual_dev_sensor_fields,
      t_update_request_graph_rx_data_mobile,
      t_update_request_graph_rx_data_mobile_pattern_mode,
      //t_graph_update_graph_selectedDate_by_devId_and_sensorId
    } = props
    //console.log(selected_desk_skeleton_mobile)

/*     selected_desk_skeleton_mobile.map((v, key) => {
      console.log(v.dev_sensors_data)
      if(v.dev_sensors_data !== null){
        v.dev_sensors_data.map(f=>{
          console.log(f)
        })
      }
    }) */
/* 
<a href={`/selected_dev_mobile/${v.dev_id}`}>👉 Dev details</a>
*/
    return (

      <Accordion defaultActiveKey={['0']} alwaysOpen>
      {selected_desk_skeleton_mobile.map((v, key) => {
/*         console.log(v.dev_color_code?.length ? v.dev_color_code[0].max_color_code : null)
        console.log(`${v.dev_color_code?.length && 'psdm__color-circle--' + v.dev_color_code[0].max_color_code}`) */
        return (
          <div key={key}>
          <Accordion.Item eventKey={`${key}`}>
          <Accordion.Header> 
            <div className="psdm__header">
              <div className={`${v.dev_color_code?.length && 'psdm__color-circle--' + v.dev_color_code[0].max_color_code}`}></div>
              <a href={`/selected_dev_mobile/${v.dev_id}`}><span className="text-info text-decoration-underline">#{v.dev_id} </span></a>
              <span className='text-info ml-1'>{v.dev_name}</span>

            </div>
 
            
            </Accordion.Header>
          <Accordion.Body>
          {
            v.dev_sensors_data?.map((m, k) => (
              <div key={k}>
                <SensorElement
                  s = {m}
                  s_index = {k}
                  dev_id = {v.dev_id}
                  update_mobile_actual_dev_sensor_fields= {update_mobile_actual_dev_sensor_fields}
                  t_update_request_graph_rx_data_mobile={t_update_request_graph_rx_data_mobile}
                  t_update_request_graph_rx_data_mobile_pattern_mode = {t_update_request_graph_rx_data_mobile_pattern_mode}
                  //t_graph_update_graph_selectedDate_by_devId_and_sensorId = {t_graph_update_graph_selectedDate_by_devId_and_sensorId}
                />
              </div>
            ))
          }
          {/* <ExampleElement /> */}
  
          </Accordion.Body>
        </Accordion.Item>

          </div>
        )
          }
        )
      }
  
      </Accordion>
    )
}

export default SDMa01accordionWrap;

const SensorElement = (props) => {
  const {s, s_index, dev_id, 
    update_mobile_actual_dev_sensor_fields,
    t_update_request_graph_rx_data_mobile,
    t_update_request_graph_rx_data_mobile_pattern_mode,
    //t_graph_update_graph_selectedDate_by_devId_and_sensorId,
  } = props

  
  //console.log('Hello!')
  //console.log(s.isExist_1yData)
  
  const API_URL_SERVICE_LINK = process.env.REACT_APP_API 
    + '/api/front_02_mobile/manager_graph_and_xlsx_data'
    + `?dev_id=${dev_id}&sensor_id=${s.sensor_id}&date_start=null&date_end=null?special_fields_array=null` // +txtPatternCode
  //https://apiwifi.hb41.uk/api/front_02_mobile/manager_graph_and_xlsx_data?dev_id=3&sensor_id=1&date_start=null&date_end=null?special_fields_array=null&txtPatternCode=NowBack24hStep30m_xlsx
  //?dev_id=3&sensor_id=1&date_start=null&date_end=null?special_fields_array=null&txtPatternCode=NowBack24hStep30m_xlsx
  //console.log('console.log(s): ', API_URL)
  //console.log(s)
  const collectDataForGraph = (graph_selected_date) => {
    //console.log('collectDataForGraph payload: ', graph_selected_date)
    const pData = {
      dev_id: dev_id,
      sensor_id: s.sensor_id,
      date_start: graph_selected_date,
      date_end: null,
      fields: s?.actual_fields,
      txtPatternCode: s?.sensor_presentation_mode?.graph_btn_fnc.txtPatternCode
                        ? s.sensor_presentation_mode.graph_btn_fnc.txtPatternCode
                        : 'day24hStep30m_timelineTime_graph',
    }
    //console.log('collectDataForGraph pData: ', pData)
    /* 
          dev_id: Number(rx.dev_id),
      sensor_id: Number(rx.sensor_id),
      date_start: rx?.date_start ? rx.date_start : null,
      date_end: rx?.date_end ? rx.date_end : null,
      special_fields_array: rx?.fields ? rx.fields : null,
      timePatternCodeId: get_timePatternCodeId(rx.txtPatternCode),
    */
      t_update_request_graph_rx_data_mobile_pattern_mode(pData)
  }  

  const array_xlsx_link = s?.sensor_presentation_mode?.template_services
  ? s.sensor_presentation_mode.template_services
  : [
    //default case 3 elements
    {
      type: "link",
      link_caption: "today.xlsx",
      txtPatternCode: "NowBack24hStep30m_xlsx",
    },
    {
      type: "link",
      link_caption: "7d.xlxs",
      txtPatternCode: "NowBack7dStep3h_xlsx",
    },
    {
      type: "link",
      link_caption: "30d.xlxs",
      txtPatternCode: "NowBack3dStep1d_xlsx",
    }
  ]
  //console.log('array_xlsx_link: ', array_xlsx_link)
  //console.log('array_xlsx_link[0].link_caption: ', array_xlsx_link[0].link_caption)
  //console.log('look2', s?.sensor_presentation_mode.graph_btn_fnc.txtPatternCode)
  https://apiwifi.hb41.uk/api/front_02_mobile/manager_graph_and_xlsx_data?dev_id=3&sensor_id=1&date_start=null&date_end=null?special_fields_array=null&txtPatternCode=NowBack24hStep30m_xlsx
 
  return (
    <div>
          <SensorTable 
          s= {s}
          dev_id = {dev_id}
          update_mobile_actual_dev_sensor_fields = {update_mobile_actual_dev_sensor_fields}
          />


            {/* Test null value */} 
                    {s.date_list && 
        <div className="d-flex flex-column justify-content-end">
        <div className="psdm__name--gray align-self-end text-sx m-2 border-bottom ">Select date</div>
        <div className="">

              <SDMa04_DateSelector 
              dateList = {s.date_list}
              //card_sensor_data = {s.last_value}
              //actual_fields_qty = {s?.actual_fields ? s.actual_fields.length : 0}
              actual_fields = {s?.actual_fields}
              //t_update_request_graph_rx_data_mobile = {t_update_request_graph_rx_data_mobile}
              collectDataForGraph = {collectDataForGraph}
              //t_graph_update_graph_selectedDate_by_devId_and_sensorId ={t_graph_update_graph_selectedDate_by_devId_and_sensorId}
            />
          </div>
          </div>            
            
            }


        {s.isExist_1yData === 1 &&
        <div className="">
          <div className="psdm__name--gray">Export xls data</div>
          <table className="table table-bordered">
            <tbody>
            <tr className="text-center">
              <td><a href={API_URL_SERVICE_LINK + '&txtPatternCode=' + array_xlsx_link[0].txtPatternCode }>{array_xlsx_link[0].link_caption}</a></td>
              <td><a href={API_URL_SERVICE_LINK + '&txtPatternCode=' + array_xlsx_link[1].txtPatternCode }>{array_xlsx_link[1].link_caption}</a></td>
              <td><a href={API_URL_SERVICE_LINK + '&txtPatternCode=' + array_xlsx_link[2].txtPatternCode }>{array_xlsx_link[2].link_caption}</a></td>
            </tr>
            </tbody>
          </table>
        </div>
        }

        {/* <a href={`/selected_dev_mobile/${dev_id}`}>👉 Dev details</a> */}

    </div>
  )
}


const SensorTable = props => {
  
  const {dev_id, s, update_mobile_actual_dev_sensor_fields} = props
  //console.log(s.sens_is_error_status)
  return (
    <table className="table table-striped">
    <thead>
    <tr>
    <th colSpan="2" className="text-left">
      <span className="psdm__name">Sensor #{s.sensor_id} {s.name} </span>
      {s.min_ago && <span className="psdm__name--gray" >min ago: {s.min_ago}</span>}
    </th>
    </tr>
  </thead>
  <tbody >
    <SDMa05_TableRow 
    s = {s} 
    dev_id = {dev_id}
    update_mobile_actual_dev_sensor_fields = {update_mobile_actual_dev_sensor_fields}
    />

  </tbody>
  </table>
  )
}

const SensorTableRow = ({dev_id, s, update_mobile_actual_dev_sensor_fields}) => {

  const actualFields = s.last_value.map(v => v.db_field)
  //update_mobile_actual_dev_sensor_fields('tmp_field_list', actualFields)
  //console.log(actualFields)

  const handleClick = (i_fieldName) => {
    if (!actualFields.includes(i_fieldName)) {
      // Add field to array if it doesn't exist
      actualFields.push(i_fieldName);
    } else {
      // Remove field from array if it exists
      const index = actualFields.indexOf(i_fieldName);
      if (index !== -1) {
        actualFields.splice(index, 1);
      }
    }
    update_mobile_actual_dev_sensor_fields('clecked_actual_fields', 
       {dev_id: dev_id,
        sensor_id: s.sensor_id,
        actual_fields: actualFields
      })
    //console.log(actualFields)
  }

  if (s.sens_is_error_status) {
    return (
    <tr>
      <td colSpan="2">
        <span className="psdm__name--gray">Sensor Error. No actual data...</span>
      </td>
    </tr>
    )
  }


  if (!s.sens_is_error_status) {
    
    return (
     s.last_value.map((v,i) => {
      const valueName = v?.card_mobile_name ? v.card_mobile_name : v.card_prefix
      const isActive = actualFields.includes(v.db_field) ? 'true' : 'false'
      //console.log(isActive)
      return (
      <tr key={i}>
      <td onClick={()=>{handleClick(v.db_field)}}><span className={isActive ? "" : "psdm__name--gray"}>{valueName}{isActive}</span></td>
      <td>{`${v.s_value}${v.card_suffix}`}</td>
    </tr>
     )})

    )
  } 
}
